module.exports = require('./helpers/bundle-url').getBundleURL('geQvc') + "arrow-down-red.dc4ab5aa.png";